export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50">密桃视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              聚合红桃视频、樱桃视频、茄子视频、糖心视频等热门站点高清内容，
              免费全集在线观看不卡顿，最新电影电视剧一网打尽，为你打造流畅观影体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={(e) => handleScroll(e, '#hero')} className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer">
                <i className="ri-wechat-line text-background-300 text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => handleScroll(e, '#hero')} className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer">
                <i className="ri-weibo-line text-background-300 text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => handleScroll(e, '#hero')} className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer">
                <i className="ri-bilibili-line text-background-300 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '精选视频', href: '#media' },
                { label: '热门话题', href: '#topics' },
                { label: '焦点专题', href: '#carousel' },
                { label: '热度榜单', href: '#ranking' },
                { label: '常见问答', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleScroll(e, link.href)}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">内容分类</h3>
            <div className="flex flex-col gap-2.5">
              {['热播电视剧', '电影大片', '综艺娱乐', '动漫番剧', '纪录片'].map((cat) => (
                <a
                  key={cat}
                  href="#media"
                  onClick={(e) => handleScroll(e, '#media')}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">
              更多合作伙伴信息即将更新，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 密桃视频 - 高清影视在线观看平台
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" onClick={(e) => handleScroll(e, '#hero')} className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">
                隐私政策
              </a>
              <a href="#hero" onClick={(e) => handleScroll(e, '#hero')} className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">
                服务条款
              </a>
              <a href="#hero" onClick={(e) => handleScroll(e, '#hero')} className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}